
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.01215 16.7967L9.01215 11.0545M14.7549 15.1615L10.1694 10.576M7.8555 10.576L3.26996 15.1615M10.6555 7.17999L10.6555 9.41944C10.6555 10.3218 9.91724 11.0601 9.01489 11.0601C8.11255 11.0601 7.37427 10.3218 7.37427 9.41944L7.37427 8.06593M3.1146 7.10797L1.47827 7.44832M13.0843 6.67047L3.45424 8.71102L2.7742 5.50106L12.4041 3.46051L13.0843 6.67047ZM15.0295 7.93652L13.4246 8.27656L12.0642 1.8566L13.6692 1.51648C14.5557 1.32871 15.4265 1.895 15.6143 2.78148L16.2945 5.99148C16.4823 6.87785 15.916 7.74871 15.0295 7.93652Z","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    